// extracted by mini-css-extract-plugin
export default {"wrapper":"J9","container":"K9","box":"L9","title":"M9","rdwrap":"N9","rditem":"O9","rdimage":"P9","name":"Q9","heading":"R9","text":"S9","guarantee":"T9","chatbox":"U9"};
    if(module.hot) {
      // 1711717535626
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  